import SignatureView from '@/modules/adjusterReportModules/components/SignatureView/SignatureView';
import { useExpertSignature } from '@/modules/adjusterReportModules/hooks/useExpertSignature';
import { FileEnType } from '@/modules/adjusterReportModules/types/signatureQueryParams.type';
import { useParams } from 'react-router-dom';

type InitialSignatureContainerProps = {
  editable: boolean;
  type: FileEnType;
};

const SignatureContainer = ({
  editable,
  type,
}: InitialSignatureContainerProps) => {
  const { id = '', damagedId = '' } = useParams<{
    id: string;
    damagedId: string;
  }>();

  const logicProps = useExpertSignature({
    id,
    damagedId,
    editable,
    type: type,
  });

  return <SignatureView type={type} {...logicProps} />;
};

export default SignatureContainer;
